<p-dialog [modal]="true" id="pdf-viewer-modal" [closable]="true" [draggable]="false" [resizable]="false"
  [(visible)]="isPdfPreviewModalShow" (onHide)="closePdfPreviewModal()" [style]="{ width: '100vw', height: '98vh' }">
  <div class="displayCenter" *ngIf="spinnerOn">
    <app-spinner [useOverlay]="false"></app-spinner>
  </div>
  <div (contextmenu)="$event.preventDefault()" (mousedown)="$event.preventDefault()" (mouseup)="$event.preventDefault()"
    tabindex="0" style="width: 100%; height: 100%;">
    <pdf-viewer *ngIf="options" [src]="options" [render-text]="true" [original-size]="false"
      style="width: 100%; height: 100%;" (after-load-complete)="onPdfLoadComplete()"
      (error)="onPdfLoadError($event)"></pdf-viewer>
  </div>
</p-dialog>